var _circle, _circle2, _path, _circle3, _circle4, _path2, _path3, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamingAvatar5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad5",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#a855f7",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "url(#grad5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 18,
    fill: "white",
    opacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 80 Q30 68 60 68 Q90 68 90 80",
    stroke: "white",
    strokeWidth: 8,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 45,
    r: 3,
    fill: "#8b5cf6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 45,
    r: 3,
    fill: "#8b5cf6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 58 Q60 65 72 58",
    stroke: "#8b5cf6",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32 L55 22 M60 32 L65 22",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    opacity: 0.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 28,
    r: 3,
    fill: "white",
    opacity: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingAvatar5);
export default __webpack_public_path__ + "static/media/gaming-avatar-5.0f5c773114a5e67573d0ec4435f993a5.svg";
export { ForwardRef as ReactComponent };